import { useCallback, useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import { type CategorySelectorState, MobileCategorySingleSelect, useInfoInitializeConfirmModal } from '@/views/build/features/category-select-view';
import { type CategoryNode, isNodeEmpty } from '@/views/build/features/category-tree';
export const GradeMobileSelection = ({
  categoryInfo
}: {
  categoryInfo: CategorySelectorState;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    openInfoInitializeConfirmModal
  } = useInfoInitializeConfirmModal();
  const shouldShowGradeSelect = useMemo(() => {
    return !!categoryInfo.grade.gradeNodes && categoryInfo.grade.gradeNodes.length > 0;
  }, [categoryInfo.grade.gradeNodes]);
  const handleValueChangeWithConfirm = useCallback(async (value: CategoryNode) => {
    const hasChildSelections = !isNodeEmpty(categoryInfo.semester.selectedSemesterNode);
    if (hasChildSelections) {
      const confirmed = await openInfoInitializeConfirmModal();
      if (!confirmed) return;
    }
    categoryInfo.updateCategoryInfo(value);
  }, [categoryInfo, openInfoInitializeConfirmModal]);
  if (!shouldShowGradeSelect) return null;
  return <MobileCategorySingleSelect value={categoryInfo.grade.selectedGradeNode?.nodeId || null} categoryNodes={categoryInfo.grade.gradeNodes ?? []} onValueChange={handleValueChangeWithConfirm} title={t('common:school.info.grade')} placeholder={t('common:school.info.grade')} error={!!categoryInfo.errors.gradeId} helperText={categoryInfo.errors.gradeId} disabled={categoryInfo.grade.gradeNodes?.length === 0} data-sentry-element="MobileCategorySingleSelect" data-sentry-component="GradeMobileSelection" data-sentry-source-file="GradeMobileSelection.tsx" />;
};